import { render, staticRenderFns } from "./PropertyType.vue?vue&type=template&id=28f1995c&"
import script from "./PropertyType.vue?vue&type=script&lang=js&"
export * from "./PropertyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports